import axios from "axios";
import { ADMIN_EMAIL, SERVICE_URL } from "@/apis/common";

const SUBJECT_REGISTRATION_CONFIRMATION =
  "Registration Confirmation - Open Links";
const MSG_REGISTRATION_CONFIRMATION = `
<!DOCTYPE html
  PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html lang="en-US">

<head>
  <meta http-equiv="Content-Type" content="text/html charset=UTF-8">
  <meta name="viewport" content="width=device-width">
  <title>Open Links Golf - Registration Confirmation</title>
</head>
<style type="text/css">
  html,
  body {
    font-family: Georgia, 'Times New Roman', Times, serif;
  }

  .t-left {
    text-align: left;
  }

  .t-right {
    text-align: right;
  }

  .t-center {
    text-align: center;
  }

  .t-center img {
    display: block;
    margin: 0 auto;
  }

  .v-top {
    vertical-align: top;
  }
</style>

<body>
  <p class="t-center">
    <img src="https://screener.openlinksgolf.com/logo-with-title.png" alt="Open Links" width="181" height="152">
  </p>
  <p>
    Thank you for registering and welcome to Open Links! Your account
    is now active and you can <a href="https://screener.openlinksgolf.com/login">log into the
    site</a>.
  </p>
  <table cellspacing="1" cellpadding="2" width="90%" align="center" border="1">
    <thead>
      <tr>
        <th colspan="6">Registration Information</th>
      </tr>
      <tr>
        <th class="t-left v-top">Name</th>
        <th class="t-left v-top">Display Name</th>
        <th class="t-left v-top">Email</th>
        <th class="t-right v-top">Amount</th>
        <th class="t-right v-top">Start Date</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="t-left v-top">$NAME</td>
        <td class="t-left v-top">$DISPLAY_NAME</td>
        <td class="t-left v-top">$EMAIL</td>
        <td class="t-right v-top">$AMOUNT_TOTAL</td>
        <td class="t-right v-top">$START_DATE</td>
      </tr>
    </tbody>
  </table>
  <p>
    To receive additional golf course and golf travel content, please follow us on <a href="https://www.instagram.com/openlinksgolf">Instagram</a>, <a href="https://www.facebook.com/openlinksgolf/">Facebook</a>, and <a href="https://twitter.com/openlinksgolf1">Twitter</a>. Our <a href="https://www.youtube.com/@openlinksgolf">YouTube</a> channel contains brief training videos to help you get started.
  </p>
  <p class="t-center">
    Questions? <a href="https://www.openlinksgolf.com/contact">Contact Us</a>
  </p>
</body>

</html>`;

function buildMailMessage(to, subject = "", htmlContent = "") {
  if (!to) {
    throw new Error("to is required");
  }

  const fromEmail = "no-reply@openlinksgolf.com";
  const fromName = "Open Links Golf";
  const bcc = "openlinksdev@gmail.com";

  return {
    from: `${fromName} <${fromEmail}>`,
    to,
    bcc,
    subject,
    html: htmlContent,
  };
}

export function sendRegistrationConfirmationMessage(summaryRow) {
  const meta = [
    {
      key: "name",
      target: "$NAME",
    },
    {
      key: "displayName",
      target: "$DISPLAY_NAME",
    },
    {
      key: "email",
      target: "$EMAIL",
    },
    {
      key: "amountTotal",
      target: "$AMOUNT_TOTAL",
    },
    {
      key: "startDate",
      target: "$START_DATE",
    },
    {
      key: "endDate",
      target: "$END_DATE",
    },
    {
      key: "nextPaymentDate",
      target: "$NEXT_PAYMENT_DATE",
    },
  ];
  const url = `${SERVICE_URL}/email`;
  const to = summaryRow.to;
  let msg_formatted = MSG_REGISTRATION_CONFIRMATION;

  meta.forEach(m => {
    const value = summaryRow[m.key];
    msg_formatted = msg_formatted.replace(m.target, value);
  });

  const msg = buildMailMessage(
    to,
    SUBJECT_REGISTRATION_CONFIRMATION,
    msg_formatted,
  );
  const headers = {
    "Content-Type": "application/json",
  };
  const config = {
    headers,
  };

  return axios.post(url, msg, config).then(res => res.data);
}

export function sendNotifyAdminRegistrationConfirmationMessage(summaryRow) {
  const to = ADMIN_EMAIL;
  const newSummaryRow = {
    ...summaryRow,
    to,
  };

  return sendRegistrationConfirmationMessage(newSummaryRow);
}
